var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.722 90.0556C171.722 44.9523 135.159 8.38892 90.0553 8.38892C44.9521 8.38892 8.38867 44.9523 8.38867 90.0556C8.38867 135.159 44.9521 171.722 90.0553 171.722C135.159 171.722 171.722 135.159 171.722 90.0556Z",
    fill: "#00397D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2853 129.648C54.8357 123.931 56.7542 118.431 59.8786 113.613C63.003 108.794 67.2414 104.799 72.2358 101.964C77.2301 99.1289 82.8335 97.538 88.5723 97.3255C94.3112 97.113 100.017 98.2852 105.207 100.743C105.632 100.95 106.094 101.071 106.565 101.098C107.037 101.126 107.51 101.06 107.956 100.904C108.402 100.748 108.813 100.505 109.164 100.189C109.516 99.8734 109.801 99.4911 110.004 99.0643C110.207 98.6376 110.324 98.1748 110.347 97.7028C110.37 97.2308 110.3 96.7589 110.139 96.3143C109.979 95.8698 109.732 95.4614 109.413 95.1128C109.094 94.7641 108.709 94.4822 108.281 94.2832C102.051 91.3308 95.2026 89.922 88.3137 90.1757C81.4248 90.4294 74.6984 92.3383 68.7031 95.7408C62.7078 99.1434 57.62 103.94 53.87 109.724C50.1199 115.508 47.8179 122.111 47.1586 128.972C47.0997 129.901 47.4044 130.815 48.0082 131.523C48.612 132.23 49.4674 132.675 50.3934 132.763C51.3193 132.851 52.2431 132.574 52.969 131.993C53.6949 131.412 54.1688 130.57 54.2853 129.648Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8893 47.2241C85.6445 47.2241 81.495 48.4828 77.9656 50.8411C74.4362 53.1994 71.6854 56.5513 70.061 60.473C68.4365 64.3946 68.0115 68.7099 68.8396 72.8732C69.6678 77.0364 71.7118 80.8605 74.7133 83.862C77.7148 86.8636 81.539 88.9076 85.7022 89.7357C89.8654 90.5639 94.1807 90.1388 98.1024 88.5144C102.024 86.89 105.376 84.1392 107.734 80.6098C110.093 77.0804 111.351 72.9309 111.351 68.6861C111.348 62.9949 109.086 57.5377 105.062 53.5134C101.038 49.4891 95.5804 47.227 89.8893 47.2241ZM89.8893 54.3781C92.7191 54.3781 95.4854 55.2173 97.8384 56.7895C100.191 58.3616 102.025 60.5962 103.108 63.2107C104.191 65.8251 104.474 68.702 103.922 71.4775C103.37 74.253 102.008 76.8024 100.007 78.8034C98.0055 80.8044 95.4561 82.1671 92.6806 82.7192C89.9051 83.2713 87.0283 82.9879 84.4138 81.905C81.7994 80.8221 79.5648 78.9882 77.9926 76.6352C76.4204 74.2823 75.5813 71.516 75.5813 68.6861C75.5827 64.8918 77.0906 61.2534 79.7736 58.5704C82.4565 55.8875 86.095 54.3796 89.8893 54.3781Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.745 115.184H107.951C107.002 115.184 106.093 115.561 105.422 116.232C104.751 116.903 104.374 117.813 104.374 118.761C104.374 119.71 104.751 120.62 105.422 121.291C106.093 121.962 107.002 122.338 107.951 122.338H120.765L116.744 126.359C116.396 126.687 116.117 127.082 115.924 127.52C115.732 127.958 115.629 128.43 115.622 128.909C115.615 129.387 115.704 129.862 115.883 130.305C116.063 130.749 116.33 131.151 116.668 131.49C117.006 131.828 117.409 132.095 117.852 132.275C118.296 132.455 118.771 132.545 119.249 132.538C119.727 132.531 120.2 132.428 120.638 132.236C121.076 132.043 121.47 131.765 121.799 131.417L131.915 121.301C132.247 120.969 132.511 120.575 132.691 120.141C132.871 119.707 132.963 119.242 132.963 118.772C132.963 118.303 132.871 117.837 132.691 117.404C132.511 116.97 132.247 116.575 131.915 116.243L121.799 106.125C121.128 105.454 120.218 105.078 119.269 105.078C118.32 105.078 117.41 105.455 116.74 106.126C116.069 106.797 115.692 107.707 115.693 108.656C115.693 109.605 116.07 110.515 116.741 111.185L120.745 115.184Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_147",
    x: 0.388672,
    y: 0.388916,
    width: 183.333,
    height: 183.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.325 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_147",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6159ba8fc6c7f3d672345cae7ea38949.svg";
export { ForwardRef as ReactComponent };